const actions = {
  //- Sets the current company
  setSelectedCompany({commit}, company) {
    commit('SET_SEL_COMPANY', company)
  },
  updateSelectedCompany({ commit }, company) {
    //- Mutate store
    commit('UPDATE_COMPANY', company)
  }
}

export default actions
